import { InfoCard } from '@/components/cards/InfoCard';
import InfoCardSkeleton from '@/components/cards/InfoCardSkeleton';
import { useDynamicLocale } from '@/hoslog-intl';
import { UserFriendIcon } from '@/icons';
import { ConversionOverviewSummary } from '@/services/dashboard/conversionAnalytics/conversionAnalytics.types';
import { Globe, MousePointer, Phone } from 'lucide-react';

interface ConversionOverviewCardsProps {
  data?: ConversionOverviewSummary | null;
  isLoading?: boolean;
}

const icons = [MousePointer, Globe, Phone, UserFriendIcon];

export const ConversionOverviewCards = ({ data, isLoading = false }: ConversionOverviewCardsProps) => {
  const { t } = useDynamicLocale();
  if (isLoading) return <InfoCardSkeleton count={4} />;
  const cards = [
    { title: t('dashboard.conversion.cards.totalClicks'), info: String(data?.totalClicks ?? 0), helperText: '' },
    {
      title: t('dashboard.conversion.cards.reservationClick'),
      info: String(data?.reservationClicks ?? 0),
      helperText: '',
    },
    { title: t('dashboard.conversion.cards.phoneCallClick'), info: String(data?.phoneCallClicks ?? 0), helperText: '' },
    { title: t('dashboard.conversion.cards.averageCTR'), info: String(data?.ctr ?? 0), helperText: '%' },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
      {cards.map(({ title, info, helperText }, index) => (
        <InfoCard key={title ?? index} title={title} info={info} helperText={helperText} icon={icons[index]} />
      ))}
    </div>
  );
};
